<div class="app-overview-container" [ngStyle]="appData.style">
    <div class="info-container">
        <finder-component-header
            [data]="appData.headerData"
        ></finder-component-header>
        <div class="icons-container">
            <a *ngIf="appData.appStoreUrl"
                [href]="appData.appStoreUrl"
                target="_blank"
                rel="noopener">
                <img [src]="appData.appStoreIcon"
                    [alt]="appData.appStoreAlt"
                    class="icon">
            </a>
            <a *ngIf="appData.playStoreUrl"
                [href]="appData.playStoreUrl"
                target="_blank"
                rel="noopener">
                <img [src]="appData.playStoreIcon"
                    [alt]="appData.playStoreAlt"
                    class="icon">
            </a>
        </div>
    </div>
    <!-- @TODO: add slider and detail components -->
    <!-- <div class="detail-container" *ngIf="appData.appDemoEnabled">
        <div class="app-detail">
            <finder-app-detail [appData]="appData.appDemoData.appDetailData"></finder-app-detail>
        </div>
        <div class="app-slider">
            <finder-app-slider [appData]="appData.appDemoData.appSliderData"></finder-app-slider>
        </div>
    </div> -->
</div>
